/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './categories';
import '../component/component';
import '../../../bbcategoriescommon/frontend/frontend';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "categories": {
                "nested": {
                  "ListCategoriesResponse": {
                    "fields": {
                      "categories": {
                        "type": "squareup.bbfrontend.common.categories.CategoryItem",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "frequentlyUsedCategories": {
                        "type": "squareup.bbfrontend.common.categories.CategoryItem",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "titleText": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "showAllButton": {
                        "type": "squareup.bbfrontend.common.component.ButtonDescription",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateCategoryResponse": {
                    "fields": {
                      "success": {
                        "type": "squareup.bbfrontend.common.categories.UpdateCategoryResponse.UpdateCategorySuccess",
                        "id": 1
                      },
                      "error": {
                        "type": "squareup.bbfrontend.common.categories.UpdateCategoryResponse.UpdateCategoryError",
                        "id": 2
                      }
                    },
                    "nested": {
                      "UpdateCategorySuccess": {
                        "fields": {
                          "transactionCategory": {
                            "type": "squareup.bbfrontend.common.categories.TransactionCategory",
                            "id": 1,
                            "rule": "optional"
                          },
                          "categoryData": {
                            "type": "squareup.bbcategoriescommon.frontend.ActivityItemDetailLineItem.CategoryData",
                            "id": 2,
                            "rule": "optional"
                          },
                          "successText": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "UpdateCategoryError": {
                        "fields": {
                          "errorText": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "result": {
                        "oneof": ["success", "error"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.categories?.nested?.ListCategoriesResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.categories?.nested?.UpdateCategoryResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.categories?.nested?.UpdateCategoryResponse?.nested?.UpdateCategorySuccess && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.categories?.nested?.UpdateCategoryResponse?.nested?.UpdateCategoryError) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListCategoriesResponse @ squareup/bbfrontend/common/categories/categories_responses.proto at 14:1
 */
export const ListCategoriesResponse = $root.lookupType('squareup.bbfrontend.common.categories.ListCategoriesResponse');
fixType(ListCategoriesResponse, {
  titleText: {
    notEmpty: true
  },
  showAllButton: {
    required: true
  }
});
Builder.createAndAttachToType(ListCategoriesResponse);
/**
 * SOURCE UpdateCategoryResponse @ squareup/bbfrontend/common/categories/categories_responses.proto at 22:1
 */
export const UpdateCategoryResponse = $root.lookupType('squareup.bbfrontend.common.categories.UpdateCategoryResponse');
fixType(UpdateCategoryResponse);
Builder.createAndAttachToType(UpdateCategoryResponse);
/**
 * SOURCE UpdateCategorySuccess @ squareup/bbfrontend/common/categories/categories_responses.proto at 28:3
 */
UpdateCategoryResponse.UpdateCategorySuccess = $root.lookupType('squareup.bbfrontend.common.categories.UpdateCategoryResponse.UpdateCategorySuccess');
fixType(UpdateCategoryResponse.UpdateCategorySuccess, {
  transactionCategory: {
    required: true
  },
  categoryData: {
    required: true
  },
  successText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateCategoryResponse.UpdateCategorySuccess);
/**
 * SOURCE UpdateCategoryError @ squareup/bbfrontend/common/categories/categories_responses.proto at 34:3
 */
UpdateCategoryResponse.UpdateCategoryError = $root.lookupType('squareup.bbfrontend.common.categories.UpdateCategoryResponse.UpdateCategoryError');
fixType(UpdateCategoryResponse.UpdateCategoryError, {
  errorText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateCategoryResponse.UpdateCategoryError);